import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { DrugService } from "./drug.service";
import { IDrug } from "./idrug";

@Injectable({
    providedIn: 'root'
})
export class DrugResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _drugService: DrugService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, drugDetails: IDrug[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._drugService.getAllDrugs(data);
    }
}